<template>
    <b-card>
        <!-- form -->
        <b-form>
            <b-row>
                <!-- new password -->
                <b-col md="6">
                    <b-form-group
                        label-for="account-new-password"
                        label="Contraseña Nueva"
                    >
                        <b-input-group class="input-group-merge">
                            <b-form-input
                                id="account-new-password"
                                v-model="newPasswordValue"
                                :type="passwordFieldTypeNew"
                                :state="isValidPassword"
                                name="new-password"
                                placeholder="Nueva Contraseña"
                                class="text-white"
                            />
                            <b-input-group-append is-text>
                                <feather-icon
                                    :icon="passwordToggleIconNew"
                                    class="cursor-pointer"
                                    @click="togglePasswordNew"
                                />
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <!--/ new password -->

                <!-- retype password -->
                <b-col md="6">
                    <b-form-group
                        label-for="account-retype-new-password"
                        label="Repita la nueva contraseña"
                    >
                        <b-input-group class="input-group-merge">
                            <b-form-input
                                id="account-retype-new-password"
                                v-model="RetypePassword"
                                :type="passwordFieldTypeRetype"
                                name="retype-password"
                                :state="isValidPassword"
                                placeholder="Nueva Contraseña"
                                v-on:blur="confirmPassword"
                                class="text-white"
                            />
                            <b-input-group-append is-text>
                                <feather-icon
                                    :icon="passwordToggleIconRetype"
                                    class="cursor-pointer"
                                    @click="togglePasswordRetype"
                                />
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <!--/ retype password -->

                <!-- buttons -->
                <b-col cols="6">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="warning"
                        class="mt-1 mr-1 float-right btn_style"
                        v-if="!loading"
                        :disabled="btnPassword"
                        @click="updatePassword"
                    >
                        Actualizar
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
        <div class="text-center">
            <b-spinner v-if="loading" variant="primary" label="Text Centered" />
        </div>
    </b-card>
</template>

<script>
import {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BSpinner
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    components: {
        BButton,
        BForm,
        BFormGroup,
        BFormInput,
        BRow,
        BSpinner,
        BCol,
        BCard,
        BInputGroup,
        BInputGroupAppend
    },
    directives: {
        Ripple
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("userData")),
            passwordValueOld: "",
            newPasswordValue: "",
            RetypePassword: "",
            passwordFieldTypeOld: "password",
            passwordFieldTypeNew: "password",
            passwordFieldTypeRetype: "password",
            btnPassword: true,
            loading: false,
            isValidPassword: null
        };
    },
    computed: {
        passwordToggleIconOld() {
            return this.passwordFieldTypeOld === "password"
                ? "EyeIcon"
                : "EyeOffIcon";
        },
        passwordToggleIconNew() {
            return this.passwordFieldTypeNew === "password"
                ? "EyeIcon"
                : "EyeOffIcon";
        },
        passwordToggleIconRetype() {
            return this.passwordFieldTypeRetype === "password"
                ? "EyeIcon"
                : "EyeOffIcon";
        }
    },
    methods: {
        togglePasswordOld() {
            this.passwordFieldTypeOld =
                this.passwordFieldTypeOld === "password" ? "text" : "password";
        },
        togglePasswordNew() {
            this.passwordFieldTypeNew =
                this.passwordFieldTypeNew === "password" ? "text" : "password";
        },
        togglePasswordRetype() {
            this.passwordFieldTypeRetype =
                this.passwordFieldTypeRetype === "password"
                    ? "text"
                    : "password";
        },

        confirmPassword() {
            if (this.newPasswordValue == this.RetypePassword) {
                this.btnPassword = false;
                this.isValidPassword = true;
            } else {
                this.btnPassword = true;
                this.isValidPassword = false;
            }
        },

        updatePassword() {
            let url = "/api/clienteUpdatePassword/";
            let me = this;
            (this.loading = true),
                this.$http
                    .put(url, {
                        idusuario: this.userData,
                        password: this.newPasswordValue
                    })
                    .then(function(response) {
                        me.showToast(
                            "Contraseña actualizado exitosamente",
                            "success",
                            "CheckCircleIcon"
                        );
                        me.loading = false;
                        me.isValidPassword = null;
                    })
                    .catch(function(error) {
                        me.loading = false;
                        me.showToast(error, "danger", "IconCancel");
                    });
        },

        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon
                }
            });
        }
    }
};
</script>

<style>
.btn_style {
    color: #004e7c !important;
}
</style>
